import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

/**
 * Provides a callback function which can be used to patch to the url passed in
 * @param url the url to patch to
 * @returns {{patchCallback: ((function(*=, *=): Promise<*>)), loading: boolean, error: boolean}}
 *
 * loading - true when patch is currently happening.
 *
 * error - true when an error has occured.
 *
 * patchCallback - the patch callback function, takes a body object and returns a promise which will contain json from the response.
 */
export function useFetchPatchV2(url) {
  const { loading, error, fetchCallback } = useLazyFetchV2("PATCH");

  return {
    loading,
    error,
    patchCallback: (body, headers = { "Content-Type": "application/json" }) =>
      fetchCallback(url, body, headers)
  };
}
